import { useNavigate } from 'react-router';
import { useStore } from '../store';
import { post } from '../lib/api';
import { Avatar } from './Avatar';

export function ChallengeBanner() {
  const { challenge, clearChallenge, notify } = useStore();
  const nav = useNavigate();
  if (!challenge) return null;
  const accept = async () => {
    try { await post(`/api/matches/${challenge.matchId}/join`); clearChallenge(); nav(`/battle/${challenge.matchId}`); } catch (e) { notify((e as Error).message, { kind: 'error' }); clearChallenge(); }
  };
  return (
    <div className="challenge" role="dialog" aria-label="Challenge">
      <Avatar u={challenge.from} />
      <div><b>{challenge.from.display_name}</b> challenged you to a battle!</div>
      <button className="btn primary sm" onClick={accept}>Accept</button>
      <button className="btn sm" onClick={clearChallenge}>Later</button>
    </div>
  );
}
